// Generated by ReScript, PLEASE EDIT WITH CARE

import Dayjs from "dayjs";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Json_encode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.mjs";
import * as PnMShiftingType$PorterinFeature from "../types/PnMShiftingType.mjs";

function encodePostalAddress(address_data) {
  return Json_encode.object_({
              hd: [
                "locality",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), address_data.locality)
              ],
              tl: {
                hd: [
                  "sub_locality",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), address_data.sub_locality)
                ],
                tl: {
                  hd: [
                    "city",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), address_data.city)
                  ],
                  tl: {
                    hd: [
                      "state",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), address_data.state)
                    ],
                    tl: {
                      hd: [
                        "pin_code",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), address_data.pincode)
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

function encodeShiftingType(shifting_type) {
  if (shifting_type === undefined) {
    return null;
  }
  switch (shifting_type.TAG | 0) {
    case /* Inter */0 :
        var data = shifting_type._0;
        return Json_encode.object_({
                    hd: [
                      "type",
                      PnMShiftingType$PorterinFeature.toString(shifting_type)
                    ],
                    tl: {
                      hd: [
                        "pickup_geo_region_id",
                        data.pickup_geo_region_id
                      ],
                      tl: {
                        hd: [
                          "drop_geo_region_id",
                          data.drop_geo_region_id
                        ],
                        tl: /* [] */0
                      }
                    }
                  });
    case /* Intra */1 :
        return Json_encode.object_({
                    hd: [
                      "type",
                      PnMShiftingType$PorterinFeature.toString(shifting_type)
                    ],
                    tl: {
                      hd: [
                        "geo_region_id",
                        shifting_type._0
                      ],
                      tl: /* [] */0
                    }
                  });
    case /* Labour */2 :
        return null;
    
  }
}

function encodeMarketingParams(marketing_params) {
  if (marketing_params === undefined) {
    return null;
  }
  var utm_source = Belt_Option.flatMap(marketing_params.utm_params, (function (utm) {
          return utm.utm_source;
        }));
  var utm_medium = Belt_Option.flatMap(marketing_params.utm_params, (function (utm) {
          return utm.utm_medium;
        }));
  var utm_campaign = Belt_Option.flatMap(marketing_params.utm_params, (function (utm) {
          return utm.utm_campaign;
        }));
  var utm_term = Belt_Option.flatMap(marketing_params.utm_params, (function (utm) {
          return utm.utm_term;
        }));
  var gclid = Belt_Option.flatMap(marketing_params.click_id, (function (click) {
          return click.gclid;
        }));
  var fbclid = Belt_Option.flatMap(marketing_params.click_id, (function (click) {
          return click.fbclid;
        }));
  return Json_encode.object_({
              hd: [
                "utm_source",
                Belt_Option.mapWithDefault(utm_source, null, (function (x) {
                        return x;
                      }))
              ],
              tl: {
                hd: [
                  "utm_medium",
                  Belt_Option.mapWithDefault(utm_medium, null, (function (x) {
                          return x;
                        }))
                ],
                tl: {
                  hd: [
                    "utm_campaign",
                    Belt_Option.mapWithDefault(utm_campaign, null, (function (x) {
                            return x;
                          }))
                  ],
                  tl: {
                    hd: [
                      "utm_term",
                      Belt_Option.mapWithDefault(utm_term, null, (function (x) {
                              return x;
                            }))
                    ],
                    tl: {
                      hd: [
                        "gclid",
                        Belt_Option.mapWithDefault(gclid, null, (function (x) {
                                return x;
                              }))
                      ],
                      tl: {
                        hd: [
                          "fbclid",
                          Belt_Option.mapWithDefault(fbclid, null, (function (x) {
                                  return x;
                                }))
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

function encodeGeoregionData(pickup, drop, mobile_number, product_flow) {
  return Json_encode.object_({
              hd: [
                "pickup",
                Json_encode.object_({
                      hd: [
                        "address",
                        pickup.landmark
                      ],
                      tl: {
                        hd: [
                          "latlng",
                          Json_encode.object_({
                                hd: [
                                  "lat",
                                  pickup.location.lat
                                ],
                                tl: {
                                  hd: [
                                    "lng",
                                    pickup.location.lng
                                  ],
                                  tl: /* [] */0
                                }
                              })
                        ],
                        tl: /* [] */0
                      }
                    })
              ],
              tl: {
                hd: [
                  "drop",
                  Json_encode.object_({
                        hd: [
                          "address",
                          drop.landmark
                        ],
                        tl: {
                          hd: [
                            "latlng",
                            Json_encode.object_({
                                  hd: [
                                    "lat",
                                    drop.location.lat
                                  ],
                                  tl: {
                                    hd: [
                                      "lng",
                                      drop.location.lng
                                    ],
                                    tl: /* [] */0
                                  }
                                })
                          ],
                          tl: /* [] */0
                        }
                      })
                ],
                tl: {
                  hd: [
                    "mobile",
                    Json_encode.object_({
                          hd: [
                            "number",
                            mobile_number
                          ],
                          tl: /* [] */0
                        })
                  ],
                  tl: {
                    hd: [
                      "product_flow",
                      product_flow
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function encodePnMCreateLeadData(form_data) {
  return Json_encode.object_({
              hd: [
                "geo_region_id",
                Belt_Option.mapWithDefault(form_data.base_form.geo_region_id, null, (function (x) {
                        return x;
                      }))
              ],
              tl: {
                hd: [
                  "name",
                  form_data.base_form.name
                ],
                tl: {
                  hd: [
                    "mobile",
                    form_data.base_form.mobile
                  ],
                  tl: {
                    hd: [
                      "shifting_date",
                      Belt_Option.mapWithDefault(form_data.base_form.date, "", (function (x) {
                              return Dayjs(x).format("YYYY-MM-DD");
                            }))
                    ],
                    tl: {
                      hd: [
                        "pickup",
                        Json_encode.object_({
                              hd: [
                                "address",
                                form_data.base_form.pickup.landmark
                              ],
                              tl: {
                                hd: [
                                  "latlng",
                                  Json_encode.object_({
                                        hd: [
                                          "lat",
                                          form_data.base_form.pickup.location.lat
                                        ],
                                        tl: {
                                          hd: [
                                            "lng",
                                            form_data.base_form.pickup.location.lng
                                          ],
                                          tl: /* [] */0
                                        }
                                      })
                                ],
                                tl: {
                                  hd: [
                                    "address_components",
                                    encodePostalAddress(form_data.base_form.pickup.extended_address)
                                  ],
                                  tl: /* [] */0
                                }
                              }
                            })
                      ],
                      tl: {
                        hd: [
                          "drop",
                          Json_encode.object_({
                                hd: [
                                  "address",
                                  form_data.base_form.drop.landmark
                                ],
                                tl: {
                                  hd: [
                                    "latlng",
                                    Json_encode.object_({
                                          hd: [
                                            "lat",
                                            form_data.base_form.drop.location.lat
                                          ],
                                          tl: {
                                            hd: [
                                              "lng",
                                              form_data.base_form.drop.location.lng
                                            ],
                                            tl: /* [] */0
                                          }
                                        })
                                  ],
                                  tl: {
                                    hd: [
                                      "address_components",
                                      encodePostalAddress(form_data.base_form.drop.extended_address)
                                    ],
                                    tl: /* [] */0
                                  }
                                }
                              })
                        ],
                        tl: {
                          hd: [
                            "source",
                            form_data.source
                          ],
                          tl: {
                            hd: [
                              "source_detail",
                              Belt_Option.mapWithDefault(form_data.source_detail, null, (function (x) {
                                      return x;
                                    }))
                            ],
                            tl: {
                              hd: [
                                "web_tracking_id",
                                Belt_Option.mapWithDefault(form_data.user_id.web_user_id, null, (function (x) {
                                        return x;
                                      }))
                              ],
                              tl: {
                                hd: [
                                  "customer_uuid",
                                  Belt_Option.mapWithDefault(form_data.user_id.customer_uuid, null, (function (x) {
                                          return x;
                                        }))
                                ],
                                tl: {
                                  hd: [
                                    "requested_at",
                                    Dayjs().unix()
                                  ],
                                  tl: {
                                    hd: [
                                      "shifting_type",
                                      encodeShiftingType(form_data.shifting_type)
                                    ],
                                    tl: {
                                      hd: [
                                        "marketing_params",
                                        encodeMarketingParams(form_data.marketing_params)
                                      ],
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

export {
  encodePostalAddress ,
  encodeShiftingType ,
  encodeMarketingParams ,
  encodeGeoregionData ,
  encodePnMCreateLeadData ,
}
/* dayjs Not a pure module */
